import { useTranslation } from 'react-i18next';
import { Menu, Search, HelpCircle, Activity } from '@/design-system/icons';
import { HeaderProps } from './types';
import { UserDropdown } from '../UserDropdown';
import { NotificationCenter } from '@/features/notifications';

export function Header({ onMenuToggle, className = '' }: HeaderProps) {
  const { t } = useTranslation();

  return (
    <header
      className={`lg:ms-64 top-0 inset-x-0 flex flex-wrap md:justify-start md:flex-nowrap z-50 bg-surface border-b border-border ${className}`}
    >
      <div className="flex justify-between xl:grid xl:grid-cols-3 basis-full items-center w-full py-2.5 px-2 sm:pr-5 md:px-5">
        <div className="xl:col-span-1 flex items-center md:gap-x-3">
          <div className="lg:hidden z-10 bg-amber-200">
            <div
              onClick={onMenuToggle}
              className="size-9 inline-flex z-10 justify-center items-center gap-x-2 text-sm font-medium rounded-lg  bg-surface text-onbackground hover:bg-surface-darker focus:outline-none focus:bg-surface-darker disabled:opacity-50 disabled:pointer-events-none"
              aria-label={t('header.toggleSidebar')}
            >
              <Menu className="size-5 sm:size-5" />
            </div>
          </div>

          {/* <div className="hidden lg:block min-w-80 xl:w-full">
            <div className="relative">
              <div className="absolute inset-y-0 start-0 flex items-center pointer-events-none z-20 ps-3.5">
                <Search className="size-4 text-onsurface/40" />
              </div>
              <input
                type="text"
                className="py-2 ps-10 pe-16 block w-full bg-field border-border rounded-lg text-sm text-onfield placeholder:text-onsurface/40 focus:outline-none focus:ring-0 disabled:opacity-50 disabled:pointer-events-none"
                placeholder={t('header.searchPlaceholder')}
              />
            </div>
          </div> */}
        </div>

        <div className="xl:col-span-2 flex justify-end items-center gap-x-2">
          <div className="flex items-center">
            <div className="lg:hidden">
              <button
                type="button"
                className="inline-flex shrink-0 justify-center items-center gap-x-2 size-9 rounded-full opacity-50 hover:bg-surface-darker focus:outline-none focus:bg-surface-darker"
                aria-label={t('header.search')}
              >
                <Search className="size-4" />
              </button>
            </div>

            <div className="hs-tooltip [--placement:bottom] inline-block">
              <button
                type="button"
                className="hs-tooltip-toggle size-9 inline-flex justify-center items-center gap-x-2 rounded-full border border-transparent opacity-50 hover:bg-surface-darker disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-surface-darker"
                aria-label={t('header.help')}
              >
                <HelpCircle className="size-4" />
              </button>
              <span
                className="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 inline-block absolute invisible z-20 py-1.5 px-2.5 bg-tooltip text-xs text-ontooltip rounded-lg"
                role="tooltip"
              >
                {t('header.helpAndSupport')}
              </span>
            </div>

            <NotificationCenter />

            <div className="hs-tooltip [--placement:bottom] inline-block">
              <button
                type="button"
                className="hs-tooltip-toggle size-9 inline-flex justify-center items-center gap-x-2 rounded-full border border-transparent opacity-50 hover:bg-surface-darker disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-surface-darker"
                aria-label={t('header.activity')}
              >
                <Activity className="size-3.5" />
              </button>
              <span
                className="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 inline-block absolute invisible z-20 py-1.5 px-2.5 bg-tooltip text-xs text-ontooltip rounded-lg"
                role="tooltip"
              >
                {t('header.activity')}
              </span>
            </div>

            <UserDropdown />
          </div>
        </div>
      </div>
    </header>
  );
}
